<div class="row small-collapse small-collapse large-collapse hp-header">
  <div class="column small-12">
    <div class="flex flex-row">
      <a href="" [routerLink]="['/']" class="hp-logo-link">
        <div
          class="hp-logo-wrapper"
          *ngIf="
            appCfg.conf.ui.logoImage &&
            appCfg.conf.ui.logoDisplayMode !== 'name_only'
          "
        >
          <div class="hp-logo">
            <img [src]="appCfg.conf.ui.logoImage" class="hp-logo-img" />
          </div>
        </div>
        <div
          class="center-name"
          *ngIf="
            appCfg.club.company &&
            (appCfg.conf.ui.logoDisplayMode === 'name_only' ||
              appCfg.conf.ui.logoDisplayMode === 'logo_and_name')
          "
        >
          {{ appCfg.club.company }}
        </div>
      </a>
      <span class="flex"></span>
      <div class="header-right-content-container">
        <app-clock></app-clock>
        <app-connected-user></app-connected-user>
        <app-lang-changer></app-lang-changer>
      </div>
    </div>
  </div>
</div>
